import { NavDropdownCustomContent, NavDropdownSeparator, NavItem, NavSwitchItem } from "./types";

export const isNavItem = (item: NavSwitchItem): item is NavItem => "name" in item;

export const isSeparator = (item: NavSwitchItem): item is NavDropdownSeparator =>
  "sep" in item && item.sep === true;

export const isContent = (item: NavSwitchItem): item is NavDropdownCustomContent => "content" in item;
